// Кто смотрит SMS-центр — по scope из bootstrap (Go RequestScope). Одно правило
// для шапки (подпись роли, баннер «Кабинет партнёра», плашка баланса) и
// «Обзора финансов»: раньше шапка считала партнёром любого без «*», а финансы —
// любого без партнёров, и сотрудник УК видел сразу и баннер партнёра, и итоги сети.

/**
 * - admin — администратор УК («*»): вся сеть, наценка УК, баланс SMSC, «Каналы».
 * - hq — сотрудник УК с доступом ко всей сети без «*»: итоги и счета сети.
 * - partner — кабинет партнёра: только свои юрлица (scope.partnerIds).
 * - limited — сотрудник УК с частью точек: ни счёта партнёра, ни итогов сети.
 */
export type ViewerRole = "admin" | "hq" | "partner" | "limited";

export function viewerRole(scope: {
  isAdmin: boolean;
  partnerIds?: string[] | null;
  allPoints?: boolean;
}): ViewerRole {
  // Как Go isPartner: партнёрские юрлица в токене — это кабинет партнёра.
  if ((scope.partnerIds?.length ?? 0) > 0) return "partner";
  if (scope.isAdmin) return "admin";
  // Старый Go не присылал allPoints — прежнее правило: без партнёров — УК.
  if (scope.allPoints === false) return "limited";
  return "hq";
}

/** Видит итоги и счета всей сети (Go AllPoints). */
export function isNetworkRole(role: ViewerRole): boolean {
  return role === "admin" || role === "hq";
}

/** Подпись роли в меню аккаунта. */
export const ROLE_LABEL: Record<ViewerRole, string> = {
  admin: "Управляющая компания",
  hq: "Сотрудник УК",
  partner: "Кабинет партнёра",
  limited: "Сотрудник УК · часть точек",
};
